// Beschriftungen, Icons und Farben des Feedback Hubs (Farben sind Namen aus src/plugins/themes, keine Hex-Werte)
export const TYPE_META = {
    bug: { label: "Bug", short: "Bug", hint: "Something isn't working", icon: "mdi-bug-outline", color: "error" },
    improvement: { label: "Improvement", short: "Improvement", hint: "Make something better", icon: "mdi-wrench-outline", color: "primary" },
    feature: { label: "Feature request", short: "Feature", hint: "Something new", icon: "mdi-lightbulb-on-outline", color: "darkgreen" }
}

export const STATUS_META = {
    pending: { label: "Under review", icon: "mdi-clock-outline", color: "grey" },
    open: { label: "Open", icon: "mdi-lightbulb-on-outline", color: "primary" },
    planned: { label: "Planned", icon: "mdi-calendar-clock", color: "darkgreen" },
    in_progress: { label: "In progress", icon: "mdi-timer-sand", color: "primary" },
    done: { label: "Done", icon: "mdi-check-circle-outline", color: "success" },
    rejected: { label: "Rejected", icon: "mdi-close-circle-outline", color: "error" },
    merged: { label: "Merged", icon: "mdi-call-merge", color: "grey" }
}

export const SUITE_LABELS = {
    research: "Research Suite",
    content: "Content Suite",
    monitoring: "Monitoring Suite",
    ai: "AI Suite",
    ki_chat: "SEO AI",
    other: "Other"
}

export const VOTABLE_STATUSES = ["open", "planned", "in_progress"]

// Hilfe fuers Formular: Platzhalter je Typ, damit klar ist, was ein guter Beitrag enthaelt
export const FORM_HINTS = {
    bug: { title: "e.g. Export button does nothing on the prompt table", description: "What did you do, what happened, and what did you expect?" },
    improvement: { title: "e.g. Make the keyword table filters easier to find", description: "What should work better, and why does it matter to you?" },
    feature: { title: "e.g. Send scheduled reports by email", description: "What would you like to do, and how would it help you?" }
}
